/** Narrow unparsed Rolodex JSON. Callers assign `postFetcher` results to `unknown` first. */

function rejectEmptyRolodexPayload(data: unknown): void {
  if (data === undefined || data === null) {
    throw new Error('Empty Rolodex response')
  }
}

export function parseRolodexRows(data: unknown): unknown[] {
  rejectEmptyRolodexPayload(data)
  if (!Array.isArray(data)) {
    throw new Error('Rolodex load did not return an array')
  }
  const rows: unknown[] = []
  for (const item of data) {
    if (item === null || typeof item !== 'object') {
      throw new Error('Rolodex load returned a non-object row')
    }
    rows.push(item)
  }
  return rows
}

export function parseRolodexCount(data: unknown): number {
  rejectEmptyRolodexPayload(data)
  if (typeof data !== 'number' || !Number.isInteger(data) || data < 0) {
    throw new Error('Rolodex load/count did not return a count')
  }
  return data
}
